import { render, staticRenderFns } from "./year-coures.vue?vue&type=template&id=f4f0a5fe"
import script from "./year-coures.vue?vue&type=script&lang=js"
export * from "./year-coures.vue?vue&type=script&lang=js"
import style0 from "./year-coures.vue?vue&type=style&index=0&id=f4f0a5fe&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports